import { getLinesGroups } from '@/stores/config'
import { useSelector } from '@/stores/hooks'
import { useLoadLinesGroups } from '../load/useLoadLinesGroups'

export function useDataLinesGroups({ level = 0 }: { level?: number } = {}) {
	const load = useLoadLinesGroups({ level })
	const linesGroups = useSelector(getLinesGroups)
	return { ...load, linesGroups }
}
